"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccountsError = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _error = require("./error");
class AccountsError extends _error.BasicError {
  /**
   * Represents a AccountsError.
   * @constructor
   */
  constructor(error, data) {
    super('Accounts API Error', error, data);
  }
}
exports.AccountsError = AccountsError;
class Accounts extends _basic.default {
  /**
   * Represents a Accounts API.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
    this.axios = this._createAxios();
  }

  /**
   * Create account
   *
   * @param {Object} data - account data
   * @async
   */
  async createAccount(data) {
    return await this._callApi({
      method: 'post',
      payload: data
    });
  }

  /**
   * Disable account
   *
   * @param {String} accountId - account id
   * @async
   */
  async disableAccount(accountId) {
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(accountId)}/disable`,
      errorData: {
        accountId
      }
    });
  }

  /**
   * Enable account
   *
   * @param {String} accountId - account id
   * @async
   */
  async enableAccount(accountId) {
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(accountId)}/enable`,
      errorData: {
        accountId
      }
    });
  }

  /**
   * Get all accounts
   * @async
   */
  async getAllAccounts() {
    return await this._callApi({
      method: 'get'
    });
  }

  /**
   * Get account by account id
   *
   * @param {String} accountId - account id
   * @async
   */
  async getAccountById(accountId) {
    return await this._callApi({
      method: 'get',
      path: `/${encodeURIComponent(accountId)}`,
      errorData: {
        accountId
      }
    });
  }

  /**
   * Get account data by account id
   *
   * @param {String} accountId - account id
   * @async
   */
  async getAccountData(accountId) {
    return await this._callApi({
      method: 'get',
      path: `/${encodeURIComponent(accountId)}/account-data`,
      errorData: {
        accountId
      }
    });
  }

  /**
   * Set account settings by key
   *
   * @param {String} accountId - account id
   * @param {Object} data - account data
   * @async
   */
  async updateAccountData(accountId, data) {
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(accountId)}`,
      payload: data,
      errorData: {
        accountId
      }
    });
  }
  async _callApi(_ref2) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {}
    } = _ref2;
    const {
      headers
    } = await this.getHeaders();
    try {
      const {
        data: responseBody
      } = await this.axios({
        method,
        url: path,
        data: JSON.stringify(payload),
        params: queryParams,
        headers
      });
      return responseBody;
    } catch (error) {
      throw new AccountsError(error, {
        statusCode: _lodash.default.get(error, 'response.status'),
        ...errorData
      });
    }
  }
  _createAxios() {
    let {
      baseUrl
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const accountsUrl = `${this.sdkApiUrl}/accounts`;
    return _axios.default.create({
      baseURL: baseUrl || accountsUrl
      // timeout : 10000
    });
  }
}
var _default = Accounts;
exports.default = _default;